var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('div',{staticClass:"close_tags_container"},[_c('div',{staticClass:"input_search_filter"},[_c('div',{staticClass:"container_filter_input_search"},[_vm._v(" "+_vm._s(_vm.tag)+" "),_c('CloseIcon',{staticClass:"close_filter_tags_assistance",on:{"click":function($event){return _vm.deleteTags(_vm.id)}}})],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }